import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { provideState, injectState } from 'freactal'
import app from '../../../../feathers'
import { getSection, sectionIndexToPath } from '../../../../lib'
import MappingDialog from '../../../components/MappingDialog'

const withState = provideState({
  initialState: () => ({
    updateSectionMappingError: null,
  }),
  effects: {
    updateSectionMapping: async (effects, { _id, sectionIndex, mapping }) => {
      try {
        const sectionPath = sectionIndexToPath(sectionIndex)
        await app.service('units').patch(_id, {
          [`sections.${sectionPath}.mapping`]: mapping,
        })
      } catch (updateSectionMappingError) {
        return () => ({ updateSectionMappingError })
      }
    },
  },
})

class SectionMapping extends Component {
  state = {
    mapping: getSection(
      this.props.state.unit,
      this.props.match.params.sectionIndex.split('.'),
    ).mapping,
    saving: false,
  }
  handleChangeMapping = mapping => this.setState({ mapping })
  saveMapping = async () => {
    const {
      match: { params: { sectionIndex } },
      state: { unit: { _id } },
      effects: { updateSectionMapping },
      history,
    } = this.props
    const { mapping } = this.state
    this.setState({ saving: true })
    await updateSectionMapping({
      _id,
      sectionIndex,
      mapping,
    })
    this.setState({ saving: false })
    history.goBack()
  }
  getDisabledMapping = ({ subsections = [], mapping }) =>
    mapping
      .map(item => ({ ...item, disabled: true }))
      .concat(...subsections.map(this.getDisabledMapping))

  getDisplayMapping() {
    const { state: { unit }, match: { params: { sectionIndex } } } = this.props
    const { mapping } = this.state
    const section = getSection(unit, sectionIndex)
    const disabledMapping = [].concat(
      ...(section.subsections || []).map(this.getDisabledMapping),
    )

    return mapping.concat(disabledMapping)
  }
  render() {
    const { history, match: { params: { sectionIndex } } } = this.props
    const { saving } = this.state
    return (
      <MappingDialog
        title={`Mapping for Section ${sectionIndex
          .split('.')
          .map(n => ++n)
          .join('.')}`}
        goBack={history.goBack}
        mapping={this.getDisplayMapping()}
        onChangeMapping={this.handleChangeMapping}
        saveMapping={this.saveMapping}
        displaySpinner={saving}
      />
    )
  }
}

export default withRouter(withState(injectState(SectionMapping)))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/SectionContent/SectionMapping.js